export default "__VITE_ASSET__DdaAMBDx__"